module.exports = __webpack_public_path__ + "img/2x.72afe67.jpg";